import { createContext } from "react";
const GPTContext = createContext();
export default GPTContext;